module.exports = __webpack_public_path__ + "static/media/spid-idp-arubaid~biXjMUPd.1f6e95c7.svg";